<template>
	<b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <working-group-create-or-update v-model="workingGroup" :errors="errors"></working-group-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="working-group"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import WorkingGroupCreateOrUpdate from './components/WorkingGroupCreateOrUpdate.vue'
import WorkingGroupApi from '@/api/operational-parameters'
import Auth from '@/utilities/auth'

export default {
	components:{
        BCard,
        WorkingGroupCreateOrUpdate,
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            workingGroup:{
                Id:0,
                Name:null,
                Code:null,
                IsVisibleFromVehicleInventory:null,
                IsOwnFirm:null
            },
            fields:[
                { name:"Çalışma Grubu",key:"Name", thClass:"w-25",sortable:true},
                { name:"Çalışma Grubu Kodu",key:"Code", thClass:"w-30",sortable:true},
                { name:"Araç Envanter Sayfasında Gösterim",key:"IsVisibleFromVehicleInventory", thClass:"w-20"},
                { name: `${Auth.companyName} Firmasına Ait`,key:"IsOwnFirm", thClass:"w-25"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.workingGroup.Id = 0
            this.workingGroup.Name = null
            this.workingGroup.Code = null
            this.workingGroup.IsVisibleFromVehicleInventory = null
            this.workingGroup.IsOwnFirm = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.workingGroup.Id = item.Id
            this.workingGroup.Name = item.Name
            this.workingGroup.Code = item.Code
            this.workingGroup.IsVisibleFromVehicleInventory = item.IsVisibleFromVehicleInventory
            this.workingGroup.IsOwnFirm = item.IsOwnFirm
            this.$showModal('create-or-update')
        },
        provider(data){
            return WorkingGroupApi.WorkingGroup.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            WorkingGroupApi.WorkingGroup.CreateOrUpdate(this.editing,this.workingGroup)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} çalışma grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    WorkingGroupApi.WorkingGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	},
}
</script>

<style>

</style>